
        var result = require("!!../../../../node_modules/css-loader/index.js!./department.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/department.component.css
// module id = 2406
// module chunks = 1